import {
    type FC
} from "react";
import type IFileUploadSourceSheetProps from "./type";
import {
    SOURCE_SHEET_LABELS,
    SOURCE_SHEET_ICONS
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import type {
    ActionSheetEntryType
} from "../../../bottomSheet/components/actionSheet/type";
import type {
    FileUploadSource
} from "../../type";
import {
    Trash2 as Trash2Icon,
    type LucideIcon
} from "lucide-react-native";
import ActionSheet from "../../../bottomSheet/components/actionSheet";

const FileUploadSourceSheet: FC<IFileUploadSourceSheetProps> = ({
    customLocalize,
    onRemovePhoto,
    onSourcePress,
    customTheme,
    description,
    onClosed,
    sources,
    variant,
    isOpen
}) => {
    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const renderIcon = (Icon: LucideIcon, isDanger: boolean = false): NCoreUIKitIcon => {
        return ({
            customColor,
            color,
            size
        }) => <Icon
            color={customColor ?? (isDanger ? colors.content.icon.danger : colors.content.icon[color])}
            size={size}
        />;
    };

    const items: Array<ActionSheetEntryType> = sources.map((source: FileUploadSource) => {
        const [
            label = "file-upload-files",
            descriptionKey = "file-upload-files-desc"
        ] = SOURCE_SHEET_LABELS[variant][source];

        return {
            icon: renderIcon(SOURCE_SHEET_ICONS[source]),
            description: localize(descriptionKey),
            onPress: () => {
                onSourcePress(source);
            },
            label: localize(label),
            key: source
        };
    });

    if(onRemovePhoto) {
        items.push({
            description: localize("file-upload-remove-photo-desc"),
            label: localize("file-upload-remove-photo"),
            icon: renderIcon(Trash2Icon, true),
            onPress: onRemovePhoto,
            key: "remove",
            type: "danger"
        });
    }

    return <ActionSheet
        title={localize(variant === "avatar" ? "file-upload-profile-photo" : "file-upload-add-files")}
        customLocalize={customLocalize}
        customTheme={customTheme}
        description={description}
        onClosed={onClosed}
        isActive={isOpen}
        items={items}
    />;
};
export default FileUploadSourceSheet;
